"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetDropZone = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var WidgetDropZoneBox_1 = require("./WidgetDropZoneBox");
exports.WidgetDropZone = function (props) {
    var isLastInSection = props.isLastInSection, dropRef = props.dropRef;
    return (react_1.default.createElement("div", { className: "widget-dropzone", ref: dropRef },
        react_1.default.createElement(WidgetDropZoneBox_1.WidgetDropZoneBox, { isLast: isLastInSection })));
};
//# sourceMappingURL=WidgetDropZone.js.map